// extracted by mini-css-extract-plugin
export default {"box_wrap":"style_box_wrap__pQfbs","img_box_wrap":"style_img_box_wrap__3D-X3","img_box_img":"style_img_box_img__5PLOf"};